import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Container,
    Paper,
    Typography,
    Button,
    Box,
    CircularProgress,
    Alert
} from '@mui/material';
import { auth } from '../config/firebase';
import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth';

const Login: React.FC = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState<string | null>(null);

    const handleGoogleLogin = async () => {
        setLoading(true);
        setError(null);

        try {
            const provider = new GoogleAuthProvider();
            const result = await signInWithPopup(auth, provider);
            
            // Simpan data user ke localStorage
            localStorage.setItem('user', JSON.stringify({
                displayName: result.user.displayName,
                email: result.user.email,
                photoURL: result.user.photoURL
            }));

            // Redirect ke halaman yang disimpan atau home
            // Simpan redirectPath sebelum menghapus dari localStorage
            const redirectPath = localStorage.getItem('redirectAfterLogin');
            if (redirectPath) {
                localStorage.removeItem('redirectAfterLogin');
                // Gunakan window.location.replace untuk force redirect
                // Ini akan memastikan redirect terjadi sebelum App.tsx melakukan redirect
                window.location.replace(redirectPath);
            } else {
                navigate('/', { replace: true });
            }
        } catch (error: any) {
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container maxWidth="sm" sx={{ mt: 8 }}>
            <Paper 
                elevation={3} 
                sx={{ 
                    p: 4, 
                    display: 'flex', 
                    flexDirection: 'column', 
                    alignItems: 'center',
                    borderRadius: 2
                }}
            >
                <Box
                    component="img"
                    src="/images/logo_booking_mabar.png"
                    alt="RaketerS Logo"
                    sx={{
                        height: 120,
                        mb: 3
                    }}
                />

                <Typography variant="h4" component="h1" gutterBottom align="center" sx={{ mb: 1 }}>
                    Login Booking Mabar RaketerS
                </Typography>

                <Typography variant="subtitle1" color="text.secondary" align="center" sx={{ mb: 4 }}>
                    Silakan login dengan akun Google Anda untuk melanjutkan
                </Typography>

                {error && (
                    <Alert severity="error" sx={{ width: '100%', mb: 2 }}>
                        {error}
                    </Alert>
                )}

                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleGoogleLogin}
                    disabled={loading}
                    startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
                    sx={{
                        py: 1.5,
                        px: 4,
                        width: '100%',
                        maxWidth: 300,
                        borderRadius: 2,
                        textTransform: 'none',
                        fontSize: '1.1rem'
                    }}
                >
                    {loading ? 'Memproses...' : 'Login dengan Google'}
                </Button>
            </Paper>
        </Container>
    );
};

export default Login; 